import { mapDTO } from '@twistezo/ts-dto-mapper'

import { WorkspacePrebidConfigurationDTO } from 'features/globalSetup/api/types/workspacePrebidConfiguration'
import { WorkspacePrebidConfiguration } from 'features/globalSetup/types/workspacePrebidConfiguration'
import { floatPercentFromDTO } from 'utils/number'

type From = WorkspacePrebidConfigurationDTO
type To = WorkspacePrebidConfiguration

export const fromDTO = (from: From): To =>
  mapDTO<From, WorkspacePrebidConfiguration>({ from }).transform(
    (workspacePrebidConfiguration: From): To => {
      const {
        allowActivitiesData,
        disablePrebidStackForUsersWithPoorInternetEnabled,
        maximumRttToEnablePrebidStack,
        s2sTimeoutMultiplier,
      } = workspacePrebidConfiguration

      return {
        ...workspacePrebidConfiguration,
        allowActivitiesData: allowActivitiesData ?? '',
        connectionSpeed: {
          disablePrebidStack: disablePrebidStackForUsersWithPoorInternetEnabled,
          maxRtt: maximumRttToEnablePrebidStack,
        },
        s2sTimeoutMultiplier: floatPercentFromDTO(s2sTimeoutMultiplier),
      }
    },
  )
